module.exports = __webpack_public_path__ + "img/Szentes Laszlo - Welder and Assembler.96849214.jpg";